function Footer() {
  return (
    <div className="wholeFooter">
      <p>Copyright © 2023 Me. All Rights Reserved.</p>
    </div>
  );
}

export default Footer;
